module.exports = __webpack_public_path__ + "static/media/readd_icon.d09dd72b.svg";